import { gql } from '@apollo/client';

export const GET_CLARIFICATION_FIELDS_LIST = gql`
  query ClarificationFields($params: FindClarificationFieldListInput!) {
    clarificationFields(params: $params) {
      success
      message
      errors
      data {
        fields {
          id
          clarificationSchemaId
          field
          label
          priority
          examples
          defaultBehavior
          applicableTo
          dynamicOptions
          stage
          valueMap
          includeInQuery
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_CLARIFICATION_FIELD = gql`
  query ClarificationField($params: FindClarificationFieldInput!) {
    clarificationField(params: $params) {
      success
      message
      errors
      data {
        id
        clarificationSchemaId
        field
        label
        priority
        examples
        defaultBehavior
        applicableTo
        dynamicOptions
        stage
        valueMap
        includeInQuery
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
